import useDefinedContext from "hooks/useDefinedContext";
import { ProfilingOneRepMaxEstimatesContext } from "../ProfilingOneRepMaxEstimatesProvider";

function useProfilingOneRepMaxEstimates() {
  return useDefinedContext(ProfilingOneRepMaxEstimatesContext);
}

export default useProfilingOneRepMaxEstimates;
